import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Passwords = React.lazy(async () => ({
    default: (await import('@oc/passwords/module')).Passwords
}))

export function PasswordsComponent() {
    return <SuspenseWhileLoading LazyComponent={Passwords} />
}
